<template>
  <v-sparkline
    v-if="!$apollo.loading"
    :value="rankingPnlSeries.datasets"
    color="#0436af"
    line-width="4"
    smooth="8"
    padding="6"
    :fill="true"
    :gradient="gradient"
    gradient-direction="top"
    :auto-draw-duration="200"
    auto-draw
  />
</template>

<script>

const RANKING_PNL_SERIES_QUERY = require('@/graphql/queries/RankingPnlSeries.gql');

export default {
  props: {
    rankingId: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      name: 'PnLSmallChart',
      nodata: true,
      gradient: ['#ceccff', '#d9d9ff', '#f2ecff']
    }
  },
  methods: {
    
  },
  apollo: {
    rankingPnlSeries: {
      fetchPolicy: "cache",
      query: RANKING_PNL_SERIES_QUERY,
      variables() {
        return {
          id: this.rankingId
        }
      },
    }
  },
};
</script>

<style lang="scss">

</style>
